import { BaseLogo } from "../../../../core/models/entities/BaseLogo";
import { LogoCommit } from "../../../../data/models/bodies/LogoCommit";
import { InitiateApproval } from "./useLogoActionsHandler";

// The two repository calls the logo-list "send for approval" flow needs.
// Narrow on purpose so the flow can be unit-tested without the whole
// action-handler hook.
export interface InitiateApprovalRepository {
  commit(logo: BaseLogo, commit: LogoCommit): Promise<BaseLogo>;
  initiateApproval(
    logo: BaseLogo,
    approval: InitiateApproval
  ): Promise<BaseLogo>;
}

// Logo list -> vendor/admin dialog -> "send for approval".
//
// Today (skipCommit=false): PUT .../logos/{id}/commit first, then
// POST .../approval-start on the committed logo. The commit route does NOT
// exist in the API (the only commit route is orders/{id}/commit), so the
// host answers 404, authFetch throws, and approval-start is never reached -
// the flow fails on every click. With the fix (flag
// approvalListFlowFixEnabled -> skipCommit=true) the commit call is skipped
// and approval-start is called with the logo as is: the API's
// InitiateApprovalProcess commits itself (CommitLogoAsync via
// PlaceVerdictAsync) when the serial is missing, exactly what the editor's
// flow relies on.
export async function runCommitAndInitiateApproval(
  repository: InitiateApprovalRepository,
  logo: BaseLogo,
  commit: LogoCommit,
  approval: InitiateApproval,
  skipCommit: boolean
): Promise<BaseLogo> {
  const subject = skipCommit ? logo : await repository.commit(logo, commit);
  return repository.initiateApproval(subject, approval);
}
